import getPBracketsCDNURL from '@pickleballinc/ui/components/global/utils/getPBracketsCDNURL';
import Link from 'next/link';

import { League } from '@/entities/League';
import { useOrganizationStore } from '@/store/organization-store';
import { DateUtil } from '@/utils/date';

interface LeagueCardProps {
	league: League;
	isHeightFitContent?: boolean;
	isMLP?: boolean;
	className?: string;
	isSearchCard?: boolean;
}

export const LeagueCard = ({ league, isHeightFitContent, isMLP, className = '', isSearchCard }: LeagueCardProps) => {
	const store = useOrganizationStore();
	const tlTimeZone = store.teamLeagueTimeZone;

	const startDateTime = DateUtil.formatUTCInTimezone(league.startDatetime, 'MMM D, YYYY', tlTimeZone?.ianaTzIdentifier);
	const endDateTime = DateUtil.formatUTCInTimezone(league.endDatetime, 'MMM D, YYYY', tlTimeZone?.ianaTzIdentifier);

	// const isRegistrationOpen =
	// 	league.registrationDateOpen &&
	// 	league.registrationDateClose &&
	// 	dayjs().isAfter(dayjs(league.registrationDateOpen)) &&
	// 	dayjs().isBefore(dayjs(league.registrationDateClose));

	return (
		<Link href={`/team-leagues/${league.slug || league.uuid}${league.isSeasonActive ? '/standings' : ''}`}>
			<div
				className={`relative h-full cursor-pointer overflow-hidden rounded-lg border border-gray-300 ${!isSearchCard ? 'w-[224px]' : ''} h-[322px] ${isMLP ? 'bg-transparent' : 'bg-white hover:bg-gray-200'} ${className}`}
			>
				{!isMLP && !league.hidePlayersCount && league.playerCount > 0 && (
					<div className="absolute left-2 top-2 rounded-[5px] bg-green-600 px-3 py-0.5 text-sm text-white">
						{league.playerCount} players
					</div>
				)}

				{/* Favoriting feature temporarily disabled */}

				{/* <div
					onClick={handleFavoriteToggle}
					className="absolute right-2 top-2 cursor-pointer transition-transform duration-150 hover:scale-105 active:scale-95"
				>
					<div className="rounded-md border border-gray-300 bg-white px-1 shadow-md">
						<FontAwesomeIcon
							icon={league.isFavourite ? solidHeart : regularHeart}
							className={`text-md transition-colors duration-150 ${league.isFavourite ? 'text-error-700' : 'text-gray-600'}`}
						/>
					</div>
				</div> */}

				<div className={'flex w-full items-center justify-center border-b border-gray-300 bg-white'} style={{ aspectRatio: '16 / 9' }}>
					<img
						src={
							league.logo?.url
								? getPBracketsCDNURL(`${league.logo?.url}`, 300, 150)
								: `${process.env.NEXT_PUBLIC_IMAGE_CDN}/placeholder/pickleball_transparent_square.png`
						}
						alt="League logo"
						className="mx-auto size-full object-contain"
					/>
				</div>
				<div className={`${isHeightFitContent ? 'h-fit' : 'h-[200px]'} flex w-full flex-col gap-2 p-4 transition-colors`}>
					{league.startDatetime && league.endDatetime ? (
						<p className={`text-sm ${isMLP ? 'font-normal leading-5 text-gray-50' : 'text-gray-500'}`}>
							{`${startDateTime} - ${endDateTime}`}
						</p>
					) : (
						league.endDatetime && <p className={`text-sm ${isMLP ? 'text-white' : 'text-gray-500'}`}>Ended on {endDateTime}</p>
					)}

					<h3
						className={`text-base ${
							isMLP ? 'font-semibold leading-6 text-white' : 'line-clamp-2 font-medium leading-tight text-gray-800'
						}`}
					>
						{league.title}
					</h3>
					{league.location ? (
						<p className={`text-sm ${isMLP ? 'text-white' : 'text-gray-500'}`}>
							{league.location.city}, {league.location.stateInfo.title}, {league.location.countryInfo.abbreviation}
						</p>
					) : null}

					{!isMLP && league.startDatetime ? (
						<p className={`text-sm ${isMLP ? 'text-white' : 'text-gray-500'}`}>Start: {startDateTime}</p>
					) : null}
					{isMLP ? <p className="text-sm text-white">{league.playerCount} players</p> : null}
				</div>
			</div>
		</Link>
	);
};
